export var AccountSuspensionRoutes = {
    "/account-suspension": {
        "name": "account-suspension",
        "clearPrevState": true,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "component": "accountSuspensionComponent",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "account suspension"
            }
        ],

        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./account-suspension.module.js");
                }
            },

        ],
    }
};
